import { render } from "./AddProjectDialog.vue?vue&type=template&id=1765cbab"
import script from "./AddProjectDialog.vue?vue&type=script&lang=js"
export * from "./AddProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__